import React from 'react';

const Logo = props => (
    <div>
        <img src="/img/logo.png" alt="The Shopping API" height="25" width="150" />
    </div>
);

export default Logo;
